import _ from 'lodash';
import React, { useState } from 'react';
import castArray from 'lodash/castArray';

import useFileUpload from '../hooks/useFileUpload';
import FormHttpBtn from './FormHttpBtn.jsx';
import FileClick from './FileClick.jsx';
import ModalAlert from './ModalAlert.jsx';

const FormHttpFileBtn = (props) => {
  const {
    api,
    children,
    className,
    icon,
    fileOpts,
    onSuccess,
  } = props;
  const [alert, setAlert] = useState(false);
  const [res, onFile] = useFileUpload({
    onSuccess,
    onError() {
      setAlert(true);
    },
  });

  return (
    <>
      <FormHttpBtn
        res={res}
        className={`position-relative ${className}`}
        icon={icon}
      >
        <FileClick
          {...fileOpts}
          onFile={(files) => onFile(api, files)}
        />
        {children}
      </FormHttpBtn>
      <ModalAlert
        size="md"
        show={alert}
        onHide={() => setAlert(false)}
      >
        {res.status === 'error' && res.code === 400 && (
          <>
            <h1>Upload Errors</h1>
            <div className="text-left">
              {castArray(res.payload).map((e, i) => (
                <div key={i}>
                  {_.isObject(e) ? JSON.stringify(e) : e}
                </div>
              ))}
            </div>
          </>
        )}
      </ModalAlert>
    </>
  );
};

export default FormHttpFileBtn;
